export const ellipsisText = (text: string, length: number): string => {
  const noNewline = text.replace(/\s/g, ' ');
  if (noNewline.length <= length) {
    return noNewline;
  }
  return noNewline.slice(0, length - 1) + '…';
};

export const trim = (text: string): string => {
  return text.replace(/^\s+|\s+$/g, '');
};

export const toComma = (value: string | number): string => {
  return Number(value).toLocaleString();
};

export const inquiryIdToThreadId = (inquiryId: string): string => {
  return inquiryId.split('_').slice(0, -1).join('_');
};

export const validateUrlParam = (
  param: string | string[] | null,
): string | undefined => {
  if (!param || typeof param !== 'string') {
    return undefined;
  }
  return param.replaceAll(/ /g, '+');
};

export const validateIntUrlParam = (str: string | null): number | undefined => {
  if (!str || typeof str !== 'string') {
    return undefined;
  }
  const parsed = Number.parseInt(str);
  if (isNaN(parsed)) {
    return;
  }
  return parsed;
};

export const encodeBase64 = async function (asciiString: string) {
  return window.btoa(asciiString);
};

export const decodeBase64 = async function (asciiString: string) {
  return window.atob(asciiString);
};

export const decodeBase64EncodeStringAndParseToJson = async function (
  encodedStringContainingJapaneseCharactor: string,
) {
  const charSet = 'utf-8';
  const decoded = fetch(
    `data:text/plain;charset=${charSet};base64,` +
      encodedStringContainingJapaneseCharactor,
  ).then((response) => response.text());
  return JSON.parse(await decoded);
};
